import { Photo } from '../components/PhotoTrio/PhotoTrio.types';

// Generate placeholder photos
export const generatePlaceholderPhotos = <T extends Photo>(count: number): T[] => {
  return Array(count)
    .fill(null)
    .map((_, index) => ({
      id: `placeholder-${index}`,
      photoUrl: ''
    })) as T[];
};
